import type { JSX } from 'react';

import { Typography } from '@mui/material';
import { Role } from 'common/types/Entities';

export const displayRoleOptionMenuItemContent = (option: Role): JSX.Element => {
    return (
        <Typography>
            {option.name}
        </Typography>
    );
};
